import { utils, LitElement, html, broadcastReceiver } from './-global.min.js'

const { addToCart, reRenderShopifySections } = utils

document.addEventListener('DOMContentLoaded', function (e) {
    const jsProductPanel = document.querySelector('.js-product-panel');
    const jsBundleAtc = document.querySelector('.js-bundle-atc');
    const customForm = document.querySelector('.js-custom-atc-form');

    if (!customForm) return;

    const variantInput = customForm.querySelector('[name="id"]');
    const submitButton = customForm.querySelector('[type="submit"]');

    document.addEventListener('variant-available::change', (event) => {
        console.log(`variant-available change: ${JSON.stringify(event.detail)}`)
        variantInput.value = event.detail.variant_id;
    });

    document.addEventListener('product-media::change', (event) => {
        console.log(`product-media change: ${JSON.stringify(event)}`);
    });

    customForm.addEventListener('submit', async function (event) {
        event.preventDefault();

        if(jsBundleAtc && jsBundleAtc?.hasAttribute('disabled')) {
            console.log('scrolling to jsProductPanel...');
            const elementPosition = jsProductPanel.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - 100;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
        else {
            console.log('sending form...');
            const bundle_selected_variants = document.querySelectorAll(".bundle-item-wrapper");
            const items = [];

            if (!bundle_selected_variants) {
                console.warn('Missing variant ID');
                return;
            }
    
            submitButton.setAttribute('disabled', true);
            submitButton.classList.add('loading');
    
            bundle_selected_variants.forEach(item => {        
                items.push({
                    id: Number(item.dataset.variantId),
                    selling_plan: item.dataset.sellingplan ? Number(item.dataset.sellingplan) : null,
                    quantity: (item.dataset.variantId == '20481231487074' || item.dataset.variantId == '39670940794978' || item.dataset.variantId == '20481231749218' || item.dataset.variantId == '20481231913058' || item.dataset.variantId == '30764227461218' || item.dataset.variantId == '30764230770786' || item.dataset.variantId == '30764229951586' || item.dataset.variantId == '41330282725474' || item.dataset.variantId == '41330282758242') ? 2 : 1
                  })
            })

            const formData = {
                items: items
            }

            reRenderShopifySections(
                await addToCart(formData)
            )
    
            utils.toggle(document.body, ['mini-cart-is-active'])
            if (utils.isTablet()) {
                document.body.style.overflow = 'hidden'
            }
    
            submitButton.removeAttribute('disabled');
            submitButton.classList.remove('loading');
        }

    });
}); 